<template>
    <div>
        <DCard
            padding
        >
            <ContactsForm
                ref="createForm"
                :errors="errors"
                :contact="contact"
                :countries="countries"
                :titles="titles"
                @submit="updateContact"
            />
        </DCard>
    </div>
</template>

<script>
import CustomerBase from '~@/Pages/Customers/Base'
import App from '~@/App.vue'

import ContactsForm from '~@/Components/Customers/Contacts/Form'

export default {
    name: 'CustomerContactEdit',
    components: {
        ContactsForm
    },
    layout: [App, CustomerBase],
    props: {
        errors: {
            type: Object,
            default: () => { return {} }
        },
        countries: {
            type: Array,
            default: () => { return [] }
        },
        titles: {
            type: Array,
            default: () => { return [] }
        },
        customerId: {
            type: Number,
            default: 0
        },
        contact: {
            type: Object,
            default: () => { return {} }
        }
    },
    methods: {
        updateContact (form) {
            form.put(this.$route('customers.customers.contacts.update', {
                customer: this.customerId,
                contact: this.contact
            }))
        }
    }
}
</script>

<style scoped>

</style>
